export class Usuario {
    pais:string;
    gerencia:string;
    area:string;
    vicepresidencia:string;
    lugar:string;
    tipo_conflicto:string;
    tipo_conflicto_id:number;
    annio:any;
    is_year:number;
    fecha_ini:string;
    fecha_fin:string;
}
